import { render, staticRenderFns } from "./PickupsList.vue?vue&type=template&id=1045a057&"
import script from "./PickupsList.vue?vue&type=script&lang=js&"
export * from "./PickupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports